const MajorsList = [
  'Accounting',
  'Actuarial Science',
  'Aerospace Engineering',
  'Anthropology',
  'Applied Math',
  'Applied Science',
  'Architecture',
  'Biochemistry',
  'Bioengineering',
  'Biology',
  'Biotechnology',
  'Business',
  'Business Analytics',
  'Chemical Engineering',
  'Chemistry',
  'Civil Engineering',
  'Cognitive Science',
  'Communications',
  'Computer Engineering',
  'Computer Science',
  'Criminology',
  'Cultural Studies',
  'Data Science',
  'Dentistry',
  'Earth Sciences',
  'East Asian Studies',
  'Economics',
  'Education',
  'Electrical Engineering',
  'Engineering',
  'Engineering Chemistry',
  'Engineering Physics',
  'English',
  'Entrepreneurship',
  'Environment',
  'Environmental Engineering',
  'Film',
  'Finance',
  'Fine Arts',
  'Food Science',
  'Geography',
  'Geological Engineering',
  'Gender Studies',
  'Graphic Design',
  'Health Science',
  'History',
  'Industrial Relations',
  'Information Systems',
  'International Development',
  'Journalism',
  'Kinesiology',
  'Law',
  'Liberal Arts',
  'Life Sciences',
  'Linguistics',
  'Literature',
  'Management',
  'Materials Engineering',
  'Mathematics',
  'Marketing',
  'Mechanical Engineering',
  'Mechatronics Engineering',
  'Medicine',
  'Mineral Engineering',
  'Mining Engineering',
  'Music',
  'Nanotechnology Engineering',
  'Neuroscience',
  'Nuclear Engineering',
  'Nursing',
  'Nutrition',
  'Information Systems',
  'Petroleum Engineering',
  'Pharmacology',
  'Philosophy',
  'Photography',
  'Physics',
  'Physiology',
  'Political Science',
  'Public Relations',
  'Psychology',
  'Religious Studies',
  'Retail Management',
  'Social Work',
  'Sociology',
  'Software Engineering',
  'Sustainability',
  'Systems Design Engineering',
  'Statistics',
  'Theatre',
  'Urban Planning',
  'Urban Systems',
  'Other',
];

export const Majors = MajorsList.map((v) => ({ label: v, value: v }));
export default Majors;
